import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

import { TagRoundingStyle, TagTheme } from './interfaces';
import { TAG_STYLE_MAP } from './constants';

@Component({
  selector: 'fcom-tag',
  styleUrls: ['tag.component.scss'],
  templateUrl: 'tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TagComponent {
  private themeService = inject(FinnairThemeService);

  readonly SiteTheme = this.themeService.siteTheme();
  readonly FinnairTheme = FinnairTheme;
  readonly TagTheme = TagTheme;
  readonly TagRoundingStyle = TagRoundingStyle;

  theme = input(TagTheme.DEFAULT);
  roundingStyle = input(TagRoundingStyle.DEFAULT);
  disabled = input(false);

  computedTheme = computed((): TagTheme => {
    if (this.SiteTheme === FinnairTheme.LEGACY) {
      return this.theme();
    }

    switch (this.theme()) {
      case TagTheme.BLACK_FRIDAY:
      case TagTheme.DEFAULT_ON_BG:
      case TagTheme.DISABLED:
      case TagTheme.ERROR:
      case TagTheme.PROMOTION:
      case TagTheme.SEMI_PROMOTION:
      case TagTheme.SUCCESS:
      case TagTheme.WARNING:
        return this.theme();
      case TagTheme.WHITE:
        return TagTheme.DEFAULT_ON_BG;
      case TagTheme.ACTIVE:
      case TagTheme.POPULAR:
        return TagTheme.PROMOTION;
      case TagTheme.ALERT:
        return TagTheme.WARNING;
      case TagTheme.DISRUPTION:
        return TagTheme.ERROR;
      default:
        return TagTheme.DEFAULT;
    }
  });

  classMapping = computed((): string => {
    if (this.disabled() && this.SiteTheme !== FinnairTheme.LEGACY) {
      return 'tag-disabled';
    }

    if (this.disabled()) {
      return '';
    }

    const style = TAG_STYLE_MAP[this.computedTheme()] ?? TAG_STYLE_MAP[TagTheme.DEFAULT];

    if (this.SiteTheme === FinnairTheme.LEGACY) {
      return `${style?.textColor} ${style?.backgroundColor}`;
    }

    return style?.tagClass !== '' ? style.tagClass : `${style?.textColor} ${style?.backgroundColor}`;
  });
}
